"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelField = exports.ModelMutator = void 0;
var core_api_1 = require("@ikegps/core-api");
var ModelMutator = /** @class */ (function () {
    function ModelMutator(field) {
        this.field = field;
    }
    Object.defineProperty(ModelMutator.prototype, "state", {
        get: function () {
            return this.field.collection.state;
        },
        enumerable: false,
        configurable: true
    });
    /** Removes the field value. */
    ModelMutator.prototype.clear = function () {
        this.state.setFieldValue(this.field.id, null);
    };
    /** Copies from the target into this Collection. */
    ModelMutator.prototype.copy = function (from) {
        var stateValue = from.stateValue;
        if (stateValue != null) {
            stateValue = JSON.parse(JSON.stringify(stateValue));
        }
        this.state.setFieldValue(this.field.id, stateValue);
        return true;
    };
    ModelMutator.prototype.truncatedCopy = function (from) {
        return true;
    };
    return ModelMutator;
}());
exports.ModelMutator = ModelMutator;
var CollectionModelField = /** @class */ (function () {
    function CollectionModelField(parent, schema) {
        this._distanceUnit = core_api_1.IkeUnitDistance.FEET;
        this.parent = parent;
        this.schema = schema;
        this.id = CollectionModelField.getStateId(this.parent, this.schema.id);
    }
    Object.defineProperty(CollectionModelField.prototype, "distanceUnit", {
        get: function () {
            return this._distanceUnit;
        },
        set: function (value) {
            this._distanceUnit = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelField.prototype, "value", {
        get: function () {
            return this._value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Fields are stored in a hash map, they need to be unique.
     * Using the subformInstanceId and the field's schema id creates a unique reference.
     */
    CollectionModelField.getStateId = function (parent, schemaId) {
        return parent.instanceId + ':' + schemaId;
    };
    Object.defineProperty(CollectionModelField.prototype, "collection", {
        /** Traverse up the tree to find the root collection for this field */
        get: function () {
            return this.parent.collection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelField.prototype, "stateValue", {
        /** Raw state value that is stored for this field */
        get: function () {
            return this.collection.state.getFieldValue(this.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelField.prototype, "displayValue", {
        get: function () {
            return String(this.stateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelField.prototype, "annotationLabel", {
        get: function () {
            return this.parent.title;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelField.prototype.findAncestorField = function (node, fieldId) {
        if (node.hasField(fieldId)) {
            return node.getField(fieldId);
        }
        if (!node.parent || !node.parent.parent) {
            return undefined;
        }
        return this.findAncestorField(node.parent.parent, fieldId);
    };
    return CollectionModelField;
}());
exports.CollectionModelField = CollectionModelField;
//# sourceMappingURL=collection.field.js.map